import { Injectable } from '@angular/core'
import { distinctUntilChanged, fromEvent, map, Observable, startWith } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class MobileService {
    isMobile$: Observable<boolean> = fromEvent(window, 'resize').pipe(
        startWith(''),
        map(() => window.innerWidth <= 956),
        distinctUntilChanged(),
    )

    isMobile(): boolean {
        return window.innerWidth <= 956
    }
}
